import { render, staticRenderFns } from "./dockingPoint.vue?vue&type=template&id=2411f96a&scoped=true"
import script from "./dockingPoint.vue?vue&type=script&lang=js"
export * from "./dockingPoint.vue?vue&type=script&lang=js"
import style0 from "./dockingPoint.vue?vue&type=style&index=0&id=2411f96a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2411f96a",
  null
  
)

export default component.exports